var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { StepContainer } from '../StepContainer';
import { buildStepConfigTree } from './utils/buildStepConfigTree';
import { mergeStepEventIntoEventRecords } from './utils/mergeStepEventIntoEventRecords';
import { getDependencyConfigKeys } from './utils/getDependencyConfigKeys';
import { getRootConfigKey } from './utils/getRootConfigKey';
var StepContainerManager = /** @class */ (function () {
    function StepContainerManager(stepConfigs, packageCache, logger, eventLogger) {
        this.packageCache = packageCache;
        this.logger = logger;
        this.eventLogger = eventLogger;
        this.stepTree = buildStepConfigTree(stepConfigs);
    }
    StepContainerManager.prototype.start = function (context) {
        return __awaiter(this, void 0, void 0, function () {
            var key;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        key = getRootConfigKey(this.stepTree);
                        return [4 /*yield*/, this.createAndRunStepInstance(key, context)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    StepContainerManager.prototype.handleEvent = function (parent, stepEvent, context) {
        return __awaiter(this, void 0, void 0, function () {
            var events, newContext, dependencyKeys, _i, dependencyKeys_1, key;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        events = mergeStepEventIntoEventRecords(context.events, stepEvent);
                        newContext = context.clone(events);
                        dependencyKeys = getDependencyConfigKeys(this.stepTree, stepEvent);
                        _i = 0, dependencyKeys_1 = dependencyKeys;
                        _a.label = 1;
                    case 1:
                        if (!(_i < dependencyKeys_1.length)) return [3 /*break*/, 4];
                        key = dependencyKeys_1[_i];
                        return [4 /*yield*/, this.createAndRunStepInstance(key, newContext, parent)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [4 /*yield*/, this.eventLogger.logStepEvent(stepEvent, parent.container)];
                    case 5:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    StepContainerManager.prototype.createAndRunStepInstance = function (configTreeKey, context, parent) {
        return __awaiter(this, void 0, void 0, function () {
            var configNode, stepPackage, container, stepNode;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        configNode = this.stepTree.get(configTreeKey);
                        if (!configNode) {
                            throw new Error("No step found for key: ".concat(configTreeKey));
                        }
                        return [4 /*yield*/, this.packageCache.get(configNode.config.uses)];
                    case 1:
                        stepPackage = _a.sent();
                        container = new StepContainer(context, stepPackage, configNode.config, this.logger);
                        stepNode = {
                            parent: parent,
                            container: container
                        };
                        configNode.stepInstances.push(stepNode);
                        container.onEventTriggered = function (stepEvent) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        // TODO: remove this when steps are passing in step name in the event
                                        stepEvent.stepName = configNode.config.name;
                                        return [4 /*yield*/, this.handleEvent(stepNode, stepEvent, context)];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); };
                        return [4 /*yield*/, container.run()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return StepContainerManager;
}());
export { StepContainerManager };
//# sourceMappingURL=StepContainerManager.js.map